import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette }: Theme) {
    const augmentPrimaryColor = { main: palette.primary.dark };
    const augmentSecondaryColor = { main: palette.secondary.dark };
    const augmentPrimary = palette.augmentColor(augmentPrimaryColor);
    const augmentSecondary = palette.augmentColor(augmentSecondaryColor);

    return {
        primaryAugmented: {
            backgroundColor: augmentPrimary.main,
            color: augmentPrimary.contrastText,
        },
        secondaryAugmented: {
            backgroundColor: augmentSecondary.main,
            color: augmentSecondary.contrastText,
        },
    };
}